<script setup lang="ts">
import AppSelectField from '@/components/AppSelectField.vue'
import type { MaterialPreviewSizeOption } from '@/material/web/previewUtils'

defineProps<{
  modelValue: string
  options: MaterialPreviewSizeOption[]
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <div v-if="options.length" class="material-preview-size-select">
    <AppSelectField
      :model-value="modelValue"
      :use-cell-style="false"
      input-class="material-preview-size-select__trigger"
      :options="options"
      @update:model-value="emit('update:modelValue', String($event))"
    />
  </div>
</template>

<style scoped>
.material-preview-size-select {
  width: 140px;
  max-width: 140px;
  flex: 0 0 140px;
  min-width: 0;
}

.material-preview-size-select :deep(.app-select-field) {
  width: 100%;
  max-width: 100%;
}

.material-preview-size-select :deep(.material-preview-size-select__trigger) {
  width: 100%;
  height: 28px;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: var(--material-font-size-base, 12px);
  line-height: 28px;
}
</style>
